
let validation = function(fields, err, hasNewPatient, user) {
    let errors = Object.assign({}, err), hasError = false;
    if(!fields.patient && !hasNewPatient) {
        errors.patient = "Porfavor seleccione un cliente.";
        hasError=true;
    }

    if(!fields.time) {
        errors.time = "Porfavor seleccione una hora para la cita.";
        hasError=true;
    }

    if(!fields.name && hasNewPatient) {
        errors.name = "Introduzca el nombre del cliente porfavor.";
        hasError = true;
    }

    if(!fields.lastname && hasNewPatient) {
        errors.lastname = "Introduzca el apellido del cliente porfavor.";
        hasError = true;
    }

    if(!fields.diagnostic) {
        errors.diagnostic = "Porfavor seleccione el servicio.";
        hasError=true;
    }

    if(!fields.pay && fields.pay !== 0) {
        errors.pay = "Porfavor agregue un pago.";
        hasError = true;
    }

    if(!fields.duration && fields.duration !== 0) {
        errors.duration = "Porfavor agregue una duración para la cita.";
        hasError = true;
    }

    if(!fields.pin) {
        errors.pin = "Porfavor introduzca su pin.";
        hasError = true;
    }

    return {errors: errors, hasError: hasError}
}

export default validation


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/home/scenes/edit-single/validation.js